module.exports = [
  {
    slug: "/data",
    bgImage: require('../assets/Home/DAIF_Menu.jpg'),
    videoTransitionIn: require('../assets/01_DATA/DAIF_Data_In.mp4'),
    videoBgLoop: require('../assets/01_DATA/DAIF_Data_Loop_Comp.mp4'),
    bgImage2: require('../assets/01_DATA/DAIF_Data_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "4%",
        height: "8%",
        top: "86.5%",
        left: "3.4%",
      },
      {
        url: "/data/1in",
        width: "24%",
        height: "4.5%",
        top: "70%",
        left: "72.4%",
      },
      {
        url: "/data/2in",
        width: "24%",
        height: "4.5%",
        top: "74.6%",
        left: "72.4%",
      },
      {
        url: "/data/3in",
        width: "24%",
        height: "4.5%",
        top: "79.2%",
        left: "72.4%",
      },
      {
        url: "/data/4in",
        width: "24%",
        height: "4.5%",
        top: "83.9%",
        left: "72.4%",
      },
      {
        url: "/data/5in",
        width: "24%",
        height: "4.5%",
        top: "88.5%",
        left: "72.4%",
      },
    ],
  },
  {
    slug: "/datab",
    bgImage: require('../assets/01_DATA/DAIF_Data_Clean.jpg'),
    videoTransitionIn: require('../assets/01_DATA/DAIF_Data_Loop_Comp.mp4'),
    videoBgLoop: require('../assets/01_DATA/DAIF_Data_Loop_Comp.mp4'),
    bgImage2: require('../assets/01_DATA/DAIF_Data_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "4%",
        height: "8%",
        top: "86.5%",
        left: "3.4%",
      },
      {
        url: "/data/1in",
        width: "24%",
        height: "4.5%",
        top: "70%",
        left: "72.4%",
      },
      {
        url: "/data/2in",
        width: "24%",
        height: "4.5%",
        top: "74.6%",
        left: "72.4%",
      },
      {
        url: "/data/3in",
        width: "24%",
        height: "4.5%",
        top: "79.2%",
        left: "72.4%",
      },
      {
        url: "/data/4in",
        width: "24%",
        height: "4.5%",
        top: "83.9%",
        left: "72.4%",
      },
      {
        url: "/data/5in",
        width: "24%",
        height: "4.5%",
        top: "88.5%",
        left: "72.4%",
      },
    ],
  },

  {
    slug: "/data/1in",
    bgImage: require('../assets/01_DATA/DAIF_Data_Clean.jpg'),
    videoTransitionIn: require('../assets/01_DATA/DAIF_Data_Screen1_in.mp4'),
    videoTransitionInEnd: require('../assets/01_DATA/DAIF_Data_Screen1_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/01_DATA/DAIF_Data_Screen1_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/data/1",
  },
  {
    slug: "/data/2in",
    bgImage: require('../assets/01_DATA/DAIF_Data_Clean.jpg'),
    videoTransitionIn: require('../assets/01_DATA/DAIF_Data_Screen2_In.mp4'),
    videoTransitionInEnd: require('../assets/01_DATA/DAIF_Data_Screen2_In-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/01_DATA/DAIF_Data_Screen2_In-end.jpg'),
    ctas: [],
    autoNavigateURL: "/data/2",
  },
  {
    slug: "/data/3in",
    bgImage: require('../assets/01_DATA/DAIF_Data_Clean.jpg'),
    videoTransitionIn: require('../assets/01_DATA/DAIF_Data_Screen3_In.mp4'),
    videoTransitionInEnd: require('../assets/01_DATA/DAIF_Data_Screen3_In-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/01_DATA/DAIF_Data_Screen3_In-end.jpg'),
    ctas: [],
    autoNavigateURL: "/data/3",
  },
  {
    slug: "/data/4in",
    bgImage: require('../assets/01_DATA/DAIF_Data_Clean.jpg'),
    videoTransitionIn: require('../assets/01_DATA/DAIF_Data_Screen1_in.mp4'),
    videoTransitionInEnd: require('../assets/01_DATA/DAIF_Data_Screen1_in-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/01_DATA/DAIF_Data_Screen1_in-end.jpg'),
    ctas: [],
    autoNavigateURL: "/data/4",
  },
  {
    slug: "/data/5in",
    bgImage: require('../assets/01_DATA/DAIF_Data_Clean.jpg'),
    videoTransitionIn: require('../assets/01_DATA/DAIF_Data_Screen2_In.mp4'),
    videoTransitionInEnd: require('../assets/01_DATA/DAIF_Data_Screen2_In-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/01_DATA/DAIF_Data_Screen2_In-end.jpg'),
    ctas: [],
    autoNavigateURL: "/data/5",
  },

  {
    slug: "/data/1",
    bgImage: require('../assets/01_DATA/DAIF_Data_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_01.mp4'),
    videoBgLoop: require('../assets/01_DATA/01_DAIF_Data_01_loop.mp4'),
    bgImage2: require('../assets/01_DATA/DAIF_Data_Screen1_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/datab",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
    ],
  },

  {
    slug: "/data/2",
    bgImage: require('../assets/01_DATA/DAIF_Data_Screen2_In-end.jpg'),
    videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_02_01.mp4'),
    videoBgLoop: require('../assets/01_DATA/01_DAIF_Data_02_01_loop.mp4'),
    bgImage2: require('../assets/01_DATA/01_DAIF_Data_02_01-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/datab",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/data/2/1",
        width: "3.3%",
        height: "5.9%",
        top: "67.5%",
        left: "81.3%",
      },
    ],
  },
  {
    slug: "/data/2/1",
    bgImage: require('../assets/01_DATA/01_DAIF_Data_02_01-end.jpg'),
    videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_02_02.mp4'),
    videoTransitionInEnd: require('../assets/01_DATA/01_DAIF_Data_02_02_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/01_DATA/DAIF_Data_Screen2_In-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/datab",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/data/2",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },

  {
    slug: "/data/3",
    bgImage: require('../assets/01_DATA/DAIF_Data_Screen3_In-end.jpg'),
    videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_03_01.mp4'),
    videoTransitionInEnd: require('../assets/01_DATA/01_DAIF_Data_03_01_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/01_DATA/01_DAIF_Data_03_01_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/datab",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/data/3/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/data/3/1",
    bgImage: require('../assets/01_DATA/01_DAIF_Data_03_01_end.jpg'),
    videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_03_02.mp4'),
    videoTransitionInEnd: require('../assets/01_DATA/01_DAIF_Data_03_02_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/01_DATA/01_DAIF_Data_03_02_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/datab",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/data/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "89.7%",
      },
      {
        url: "/data/3/2",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/data/3/2",
    bgImage: require('../assets/01_DATA/01_DAIF_Data_03_02_end.jpg'),
    videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_03_03.mp4'),
    videoTransitionInEnd: require('../assets/01_DATA/01_DAIF_Data_03_03_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/01_DATA/DAIF_Data_Screen3_In-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/datab",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/data/3/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },

  {
    slug: "/data/4",
    bgImage: require('../assets/01_DATA/DAIF_Data_Screen1_in-end.jpg'),
    videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_04_01.mp4'),
    videoTransitionInEnd: require('../assets/01_DATA/01_DAIF_Data_04_01_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/01_DATA/01_DAIF_Data_04_01_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/datab",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/data/4/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/data/4/1",
    bgImage: require('../assets/01_DATA/01_DAIF_Data_04_01_end.jpg'),
    videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_04_02.mp4'),
    videoBgLoop: require('../assets/01_DATA/01_DAIF_Data_04_02_loop.mp4'),
    bgImage2: require('../assets/01_DATA/01_DAIF_Data_04_02-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/datab",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/data/4",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "89.7%",
      },
      {
        url: "/data/4/5", // /4/2
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  // {
  //   slug: "/data/4/2",
  //   bgImage: require('../assets/01_DATA/01_DAIF_Data_04_02-end.jpg'),
  //   videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_04_03.mp4'),
  //   videoBgLoop: require('../assets/01_DATA/01_DAIF_Data_04_03_loop.mp4'),
  //   bgImage2: require('../assets/01_DATA/01_DAIF_Data_04_03-end.jpg'),
  //   ctas: [
  //     {
  //       url: "/",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "3.6%",
  //     },
  //     {
  //       url: "/datab",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "7.4%",
  //     },
  //     {
  //       url: "/data/4/1",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "89.7%",
  //     },
  //     {
  //       url: "/data/4/3",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "93.3%",
  //     },
  //   ],
  // },
  // {
  //   slug: "/data/4/3",
  //   bgImage: require('../assets/01_DATA/01_DAIF_Data_04_03-end.jpg'),
  //   videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_04_04.mp4'),
  //   videoBgLoop: require('../assets/01_DATA/01_DAIF_Data_04_04_loop.mp4'),
  //   bgImage2: require('../assets/01_DATA/01_DAIF_Data_04_04-end.jpg'),
  //   ctas: [
  //     {
  //       url: "/",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "3.6%",
  //     },
  //     {
  //       url: "/datab",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "7.4%",
  //     },
  //     {
  //       url: "/data/4/2",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "89.7%",
  //     },
  //     {
  //       url: "/data/4/4",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "93.3%",
  //     },
  //   ],
  // },
  // {
  //   slug: "/data/4/4",
  //   bgImage: require('../assets/01_DATA/01_DAIF_Data_04_04-end.jpg'),
  //   videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_04_05.mp4'),
  //   videoBgLoop: require('../assets/01_DATA/01_DAIF_Data_04_05_loop.mp4'),
  //   bgImage2: require('../assets/01_DATA/01_DAIF_Data_04_05-end.jpg'),
  //   ctas: [
  //     {
  //       url: "/",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "3.6%",
  //     },
  //     {
  //       url: "/datab",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "7.4%",
  //     },
  //     {
  //       url: "/data/4/3",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "89.7%",
  //     },
  //     {
  //       url: "/data/4/5",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "93.3%",
  //     },
  //   ],
  // },
  {
    slug: "/data/4/5",
    bgImage: require('../assets/01_DATA/01_DAIF_Data_04_02-end.jpg'), // 04_05-end.jpg
    videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_04_06.mp4'),
    videoTransitionInEnd: require('../assets/01_DATA/01_DAIF_Data_04_06_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/01_DATA/01_DAIF_Data_04_06_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/datab",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/data/4/1", // /4/4
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "89.7%",
      },
      {
        url: "/data/4/6",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/data/4/6",
    bgImage: require('../assets/01_DATA/01_DAIF_Data_04_06_end.jpg'),
    videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_04_07.mp4'),
    videoTransitionInEnd: require('../assets/01_DATA/01_DAIF_Data_04_07_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/01_DATA/DAIF_Data_Screen1_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/datab",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/data/4/5",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },

  {
    slug: "/data/5",
    bgImage: require('../assets/01_DATA/DAIF_Data_Screen2_In-end.jpg'),
    videoTransitionIn: require('../assets/01_DATA/01_DAIF_Data_05.mp4'),
    videoBgLoop: require('../assets/01_DATA/01_DAIF_Data_05_Loop.mp4'),
    bgImage2: require('../assets/01_DATA/DAIF_Data_Screen1_in-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/datab",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      }
    ],
  },
]